import HotelsSearchControlsGCWrapper from './HotelsSearchControlsGCWrapper';

export default HotelsSearchControlsGCWrapper;
